import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidenavComponent } from './sidenav.component';
import { MaterialModuleMobi } from '../material/material.module';
import { SidenavContentModule } from '../sidenav-content/sidenav-content.module';
import { SidenavContentListModule } from '../sidenav-content-list/sidenav-content-list.module';
import { AppPermissionsPipe } from 'shared-library';


@NgModule({
  declarations: [
    SidenavComponent
  ],
  imports: [
    CommonModule,
    MaterialModuleMobi,
    SidenavContentModule,
    SidenavContentListModule,
    AppPermissionsPipe    
  ],
  exports:[
    SidenavComponent
  ]
})
export class SidenavModule { }
